import { Navigate, useParams } from 'react-router-dom';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveGastos } from '../../shared/components';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetGasto } from '@/shared/actions/erp/inventario/gastos.actions';
import { PermissionsEnum } from '@/auth/interfaces';

export type UpdateGastosPageProps = {};
export const returnUrlGastosPage= ROUTER_PATHS.inventario.gastos_nav


const UpdateGastosPage: React.FC<UpdateGastosPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_gasto)

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetGasto(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id_gasto) return <Navigate to={returnUrlGastosPage} />;

  return <SaveGastos titlePage="Editar Gastos" editGastos={data.data} />;
};

export default UpdateGastosPage;